<template>
  <div v-show="total > 0" class="show-items-label">
    <div>
      Показано <b>{{ count }}</b> из <b>{{ total }}</b>
    </div>
  </div>
</template>

<script>
export default {
  props: ["count", "total"],
};
</script>

<style lang="scss">
.show-items-label {
  position: fixed;
  bottom: 10px;
  right: 10px;

  display: flex;
  align-items: center;
  padding: 5px 20px;
  height: 30px;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(0, 15, 38, 0.25);
  border-radius: 50px;
  z-index: 5;

  font-size: 12px;

  b {
    font-weight: 500;
  }
}

.scroll-top-button.active + .show-items-label {
  right: 50px;
}
</style>
